<template>
  <div id="etoak">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'Etoak',
    created() {
      //在页面加载时读取sessionStorage里的状态信息
      if (sessionStorage.getItem("store")) {
        this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("store"))))
      }

      //在页面刷新时将vuex里的信息保存到sessionStorage里
      window.addEventListener("beforeunload", () => {
        sessionStorage.setItem("store", JSON.stringify(this.$store.state))
      })
    },
    beforeDestroy() {
      if (!this.$vuetify) return

      this.$vuetify.theme.dark = true
    },
    mounted() {
      const script = document.createElement('script')
      script.src = 'https://v1.cnzz.com/z_stat.php?id=1278903771&web_id=1278903771'
      script.language = 'JavaScript'
      document.body.appendChild(script)
    },
    watch: {
      '$route'() {
        if (window._czc) {
          let location = window.location
          let contentUrl = location.pathname + location.hash
          let refererUrl = '/'
          window._czc.push(['_trackPageview', contentUrl, refererUrl])
        }
      }
    }
  }
</script>

<style>
  html {
    overflow-y: auto
  }
</style>



// WEBPACK FOOTER //
// src/etoak.vue